import { Form, MaskedInput, Row, Table } from '@bancobarigui/barihaus';

export function ValueRangeItem() {
  return (
    <div className="flex flex-col gap-4">
      <Row>Defina o valor mínimo e máximo.</Row>

      <Table
        bordered={true}
        columns={[
          {
            dataIndex: 'name',
            key: 'name',
            title: '',
          },
          {
            dataIndex: 'min',
            key: 'min',
            title: 'Mínimo',
          },
          {
            dataIndex: 'max',
            key: 'max',
            title: 'Máximo',
          },
        ]}
        dataSource={[
          {
            name: 'Valor',
            min: (
              <Form.Item
                name="minValue"
                rules={[{ required: true, message: 'Informe o valor mínimo.' }]}
              >
                <MaskedInput type="money" onChange={() => {}} value="" />
              </Form.Item>
            ),
            max: (
              <Form.Item
                name="maxValue"
                rules={[{ required: true, message: 'Informe o valor máximo.' }]}
              >
                <MaskedInput type="money" onChange={() => {}} value="" />
              </Form.Item>
            ),
          },
        ]}
      />
    </div>
  );
}
